import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditHallTicketTemplate from './AddEditHallTicketTemplate';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const HallTicketTemplate = () => {
    const { catchResponse } = useCatchResponse();
    const [templateList, setTemplateList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        TemplateName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [academicYearList, setAcademicYearList] = useState([]);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData?._id);
    }, []);

    const getFinancialYearData = async (id) => {
        const years = await CommonConfig.getFinancialYears(id);
        setAcademicYearList(years);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetTemplateList(id, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetTemplateList = async (id, financialId) => {
        try {
            Loader.show();
            let data = { UserID: id, FinancialYearId: financialId };
            await api.post(APIConstant.path.GetHallTicketTemplateList, data).then(async response => {
                if (response.success) {
                    setTemplateList(response.data);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-my-0 p-m-0" onClick={() => {
                        setMasterData(rows);
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-my-0 p-mr-0 p-ml-2" onClick={() => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                </div>
            </React.Fragment>
        );
    };

    const lastUpdatedBodyTemplate = (rows) => {
        return (<div>{moment(rows?.UpdatedOn).format("DD-MM-YYYY HH:mm")}</div>);
    };

    const onCancel = () => {
        setVisible(false);
        setMasterData([]);
        GetTemplateList(securityUserID, selectedYear);
    }

    const actionBodyTemplateSrNo = (data, props) => props.rowIndex + 1;

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button label="Cancel" className="btn-text-action-secondary" onClick={handleClose} />
            <Button label="Delete" className="btn-text-action-primary" onClick={() => DeleteItem()} />
        </div>
    );

    const handleClose = () => setIsDeleteConfirmation(false);

    const DeleteItem = async () => {
        try {
            let data = { id: deleteId };
            await api.post(APIConstant.path.DeleteHallTicketTemplate, data).then(async response => {
                if (response.success) {
                    Loader.hide();
                    Toast.success({ message: 'Hall Ticket template deleted successfully' });
                    GetTemplateList(securityUserID, selectedYear);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                handleClose();
                catchResponse(err);
            });
        } catch (err) {
            catchResponse(err);
        }
    }

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-id-card"></i>
                    <h2>Hall Ticket Template</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={templateList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                globalFilterFields={['TemplateName']}
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                <Column field="TemplateName" header="Template Name" />
                <Column field="ClassName" header="Class Name" />
                <Column body={lastUpdatedBodyTemplate} header="Last Updated On" />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: 'auto', textAlign: 'end' }} />
            </DataTable>

            <Dialog
                header={masterData?._id ? 'Edit Hall Ticket Template' : 'Add Hall Ticket Template'}
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '80%' }}
                contentStyle={{ overflow: 'hidden' }}
            >
                <AddEditHallTicketTemplate onCancel={onCancel} configId={masterData?._id} masterData={masterData} financialYearId={selectedYear} academicYearList={academicYearList} />
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={<div className="p-d-flex p-jc-between p-ai-center"><span>Delete Confirmation</span></div>}
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default HallTicketTemplate;
